import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ContactModal from "./ContactModal";
import "./ProcessSection.css";

const ProcessSection = () => {
  const [activeTab, setActiveTab] = useState("ux");
  const [isDesktop, setIsDesktop] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tabs = [
    { id: "ux", label: "UX/UI" },
    { id: "branding", label: "Branding" },
    { id: "development", label: "Developpement" },
  ];

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth > 1200);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const processSteps = {
    ux: [
      { label: "Recherche & Discovery", position: { top: 0, left: 53 } },
      { label: "Personas & Parcours", position: { top: 0, left: 285 } },
      { label: "Wireframes", position: { top: 68, left: 470 } },
      { label: "UI Design", position: { top: 136, left: 615 } },
      { label: "Prototypes", position: { top: 136, left: 965 } },
      { label: "Tests Utilisateurs", position: { top: 203, left: 965 } },
      { label: "Handoff", position: { top: 203, left: 1239 } },
    ],
    branding: [
      { label: "Brief & Analyse", position: { top: 0, left: 53 } },
      { label: "Moodboard", position: { top: 0, left: 285 } },
      { label: "Logo Design", position: { top: 68, left: 470 } },
      { label: "Identité Visuelle", position: { top: 136, left: 615 } },
      { label: "Guidelines", position: { top: 136, left: 965 } },
      { label: "Applications", position: { top: 203, left: 965 } },
    ],
    development: [
      { label: "Architecture", position: { top: 0, left: 53 } },
      { label: "Setup & Config", position: { top: 0, left: 285 } },
      { label: "Développement", position: { top: 68, left: 470 } },
      { label: "Tests & QA", position: { top: 136, left: 615 } },
      { label: "Déploiement", position: { top: 136, left: 965 } },
      { label: "Maintenance", position: { top: 203, left: 965 } },
    ],
  };

  return (
    <section id="process" className="process-section">
      <div className="process-container">
        <h2 className="process-title">Notre secret sauce</h2>

        <div className="process-content">
          {isDesktop ? (
            <>
              {/* Desktop: Tabs */}
              <div className="process-tabs">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`process-tab ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Desktop: Flow for active tab */}
              <div className="process-flow" id="process-flow">
                <div className="process-steps">
                  {processSteps[activeTab].map((step, index) => {
                    const steps = processSteps[activeTab];
                    const nextStep = steps[index + 1];
                    const availableWidth = nextStep
                      ? nextStep.position.left - step.position.left - 20
                      : 400;
                    return (
                      <div
                        key={index}
                        className="process-step"
                        style={{
                          position: "absolute",
                          top: `${step.position.top}px`,
                          left: `${step.position.left}px`,
                          width: computeStepWidth(
                            step.label,
                            index,
                            availableWidth
                          ),
                        }}
                      >
                        <span className="step-label">{step.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          ) : (
            /* Mobile/Tablet: Slider */
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              className="process-swiper"
            >
              {[
                { id: "ux", label: "UX/UI" },
                { id: "branding", label: "Branding" },
                { id: "development", label: "Developpement" },
              ].map((cat) => (
                <SwiperSlide key={cat.id}>
                  <div className="process-slide">
                    <div className="process-tabs single">
                      <button className="process-tab active">
                        {cat.label}
                      </button>
                    </div>
                    <div className="process-flow" id={`process-flow-${cat.id}`}>
                      <div className="process-steps">
                        {processSteps[cat.id].map((step, index) => {
                          const steps = processSteps[cat.id];
                          const nextStep = steps[index + 1];
                          const availableWidth = nextStep
                            ? nextStep.position.left - step.position.left - 20
                            : 400;
                          return (
                            <div
                              key={index}
                              className="process-step"
                              style={{
                                position: "absolute",
                                top: `${step.position.top}px`,
                                left: `${step.position.left}px`,
                                width: "auto",
                              }}
                            >
                              <span className="step-label">{step.label}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="process-bottom">
          <h2 className="process-bottom-title">Passons aux choses sérieuses</h2>
          <p className="process-bottom-description">
            Vous parlerez directement avec notre équipe — pas de robot
            commercial, juste des réponses claires.
          </p>

          <button className="process-cta" onClick={() => setIsModalOpen(true)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4469 16.377L20.2939 10.547C21.1359 9.708 21.5569 9.288 21.7779 8.755C21.9989 8.222 21.9999 7.627 21.9999 6.44V5.873C21.9999 4.047 21.9999 3.134 21.4309 2.567C20.8619 2 19.9469 2 18.1159 2H17.5459C16.3559 2 15.7609 2 15.2259 2.221C14.6899 2.442 14.2689 2.862 13.4259 3.701L7.57994 9.531C6.59594 10.511 5.98594 11.12 5.74994 11.707C5.67684 11.8854 5.63881 12.0762 5.63794 12.269C5.63794 13.071 6.28494 13.717 7.57994 15.008L7.75394 15.181L9.79194 13.112C9.86108 13.0418 9.94337 12.9859 10.0341 12.9475C10.1248 12.9091 10.2223 12.889 10.3208 12.8883C10.4193 12.8875 10.517 12.9062 10.6083 12.9432C10.6996 12.9802 10.7827 13.0349 10.8529 13.104C10.9231 13.1731 10.979 13.2554 11.0174 13.3462C11.0558 13.4369 11.0759 13.5343 11.0767 13.6328C11.0774 13.7314 11.0588 13.8291 11.0217 13.9204C10.9847 14.0117 10.9301 14.0948 10.8609 14.165L8.81594 16.24L8.95294 16.377C10.2479 17.667 10.8959 18.313 11.6999 18.313C11.8779 18.313 12.0479 18.282 12.2189 18.219C12.8219 17.997 13.4379 17.383 14.4469 16.377Z"
                fill="white"
              />
              <path
                opacity="0.5"
                d="M9.03403 5.96288L6.49103 8.49988C6.02403 8.96588 5.59503 9.39288 5.25603 9.77988C5.02663 10.035 4.81954 10.3094 4.63703 10.5999L4.61303 10.5749L4.51803 10.4809C4.07501 10.0529 3.55526 9.71228 2.98603 9.47688L2.86303 9.42688L2.48403 9.27688C2.366 9.23035 2.26142 9.15515 2.17972 9.05809C2.09802 8.96102 2.04179 8.84514 2.01609 8.7209C1.99038 8.59666 1.99603 8.46797 2.03251 8.34646C2.06898 8.22494 2.13515 8.11442 2.22503 8.02488C3.34503 6.90688 4.69003 5.56588 5.34003 5.29688C5.90457 5.06107 6.52228 4.98195 7.12803 5.06788C7.67403 5.14888 8.19003 5.42988 9.03403 5.96288Z"
                fill="white"
              />
            </svg>
            <span>Passons à l'action</span>
          </button>
        </div>
      </div>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default ProcessSection;

function computeStepWidth(label, index, availableWidth) {
  const baseWidthPx = 160; // minimum base width
  const labelBasedMinPx = Math.ceil(label.length * 9 + 40); // minimum width for text
  const minWidth = Math.max(baseWidthPx, labelBasedMinPx);

  // Use most of the available width, but leave some gap
  const targetWidth = Math.max(minWidth, availableWidth - 10);

  return `${targetWidth}px`;
}
